export const parametersReducer = (state = {loading: true, resultparameter: null, parameters: null, initialBalance: null, parameter: null } , action) => {
    switch (action.type) {
        case 'PARAMETER_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                parameters: action.payload.parameters
            }
        case 'PARAMETER_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                parameter: action.payload
            }
        case 'PARAMETER_ADD_SUCCESS':
            return {
                ...state,
                loading:false,
                parameters: [...state.parameters, action.payload.parameter],
                resultparameter: action.payload.message
            }
        case 'PARAMETER_EDIT_SUCCESS':
            return {
                ...state,
                loading:false,
                parameters: state.parameters.map(parameter => parameter._id === action.payload.parameter._id ? action.payload.parameter : parameter),
                resultparameter: action.payload.message
            }
        case 'PARAMETER_REMOVE_RESULT':
            return {
                ...state,
                loading:false,
                resultparameter: action.payload.message,
                parameters: state.parameters.filter(parameters => parameters._id !== action.payload.parameter)
            }
        case 'PARAMETER_RESET_RESULT':
            return {...state,
                resultparameter: null
            }
        case 'PARAMETER_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'PARAMETER_NOT_LOADING':
            return {
                ...state,
                loading:false
            }
        case 'PARAMETERS_RESET':
            return {
                ...state,
                parameters: null                
        }
        default:
            return state
    }
}

